/* eslint-disable */
export default {
  ringtones: '벨소리',
  incomingRingtone: '수신 벨소리',
  outgoingRingtone: '발신 벨소리',
  play: '재생',
  stop: '중지',
  upload: '업로드',
  reset: '재설정',
  save: '저장',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
